// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
  --profile-bg: #f3f5fb;
  --profile-surface: #ffffff;
  --profile-text: #1f2a44;
  --profile-muted: #64748b;
  --profile-border: #dbe3f2;
  --profile-primary: #0d6ba8;
  --profile-primary-soft: #e6f3fb;
  --profile-shadow: 0 14px 34px rgba(31, 42, 68, 0.08);
  --profile-font: "Poppins", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-family: var(--profile-font);
  min-height: calc(100vh - 80px);
  padding: 24px 16px 36px;
  background:
    radial-gradient(1200px 420px at 90% -140px, rgba(13, 107, 168, 0.18), transparent 60%),
    linear-gradient(180deg, #f8fafe 0%, var(--profile-bg) 45%, #eef2f8 100%);
}

.profile-shell {
  width: min(1200px, 100%);
  margin: 0 auto;
  display: grid;
  gap: 20px;
}

.profile-hero {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid var(--profile-border);
  border-radius: 18px;
  box-shadow: var(--profile-shadow);
  padding: 26px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 24px;
}

.profile-avatar-wrap {
  width: 130px;
  height: 130px;
  border-radius: 999px;
  padding: 4px;
  background: linear-gradient(135deg, #52a8d8, #245f95);
  box-shadow: 0 10px 24px rgba(36, 95, 149, 0.24);
}

.profile-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
  border: 3px solid #ffffff;
}

.profile-main {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.profile-name {
  margin: 0;
  color: var(--profile-text);
  font-size: clamp(1.6rem, 2vw, 2rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0.01em;
}

.profile-email {
  margin: 6px 0 12px;
  color: #475569;
  font-size: 0.98rem;
}

.profile-meta-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 10px;
}

.profile-meta-item {
  border: 1px solid var(--profile-border);
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  padding: 10px 12px;
}

.profile-meta-label {
  display: block;
  margin-bottom: 2px;
  font-size: 0.74rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--profile-muted);
  font-weight: 600;
}

.profile-meta-value {
  color: var(--profile-text);
  font-size: 0.95rem;
  font-weight: 600;
}

.profile-cards {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 18px;
}

.profile-card {
  background: var(--profile-surface);
  border: 1px solid var(--profile-border);
  border-radius: 16px;
  box-shadow: var(--profile-shadow);
  padding: 18px 18px 14px;
  animation: profile-fade-in 360ms ease both;
}

.profile-card-title {
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--profile-border);
  font-size: 1.36rem;
  font-weight: 700;
  color: var(--profile-text);
}

.profile-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.profile-list li {
  padding: 10px 0;
  border-bottom: 1px dashed #d6dfef;
  color: #334155;
  font-size: 0.95rem;
}

.profile-list li:last-child {
  border-bottom: 0;
}

.profile-field-label {
  display: block;
  margin-bottom: 8px;
  color: var(--profile-muted);
  font-size: 0.87rem;
  font-weight: 600;
}

.profile-helper {
  margin-top: 12px;
  margin-bottom: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--profile-primary-soft);
  border: 1px solid #cae8fb;
  color: #0e537f;
  font-size: 0.88rem;
}

.card-enterprises {
  grid-column: span 4;
}

.card-notifications {
  grid-column: span 4;
}

.card-timezone {
  grid-column: span 4;
}

@keyframes profile-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1024px) {
  .card-enterprises,
  .card-notifications,
  .card-timezone {
    grid-column: span 6;
  }
}

@media (max-width: 768px) {
  .profile-page {
    padding: 16px 10px 28px;
  }

  .profile-hero {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
    gap: 14px;
    padding: 22px 16px;
  }

  .profile-meta-grid {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .profile-cards {
    grid-template-columns: 1fr;
  }

  .card-enterprises,
  .card-notifications,
  .card-timezone {
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/myProfile.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,oDAAoD;EACpD,0EAA0E;EAC1E,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB;;4EAE0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":[".profile-page {\n  --profile-bg: #f3f5fb;\n  --profile-surface: #ffffff;\n  --profile-text: #1f2a44;\n  --profile-muted: #64748b;\n  --profile-border: #dbe3f2;\n  --profile-primary: #0d6ba8;\n  --profile-primary-soft: #e6f3fb;\n  --profile-shadow: 0 14px 34px rgba(31, 42, 68, 0.08);\n  --profile-font: \"Poppins\", \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  font-family: var(--profile-font);\n  min-height: calc(100vh - 80px);\n  padding: 24px 16px 36px;\n  background:\n    radial-gradient(1200px 420px at 90% -140px, rgba(13, 107, 168, 0.18), transparent 60%),\n    linear-gradient(180deg, #f8fafe 0%, var(--profile-bg) 45%, #eef2f8 100%);\n}\n\n.profile-shell {\n  width: min(1200px, 100%);\n  margin: 0 auto;\n  display: grid;\n  gap: 20px;\n}\n\n.profile-hero {\n  position: relative;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid var(--profile-border);\n  border-radius: 18px;\n  box-shadow: var(--profile-shadow);\n  padding: 26px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 24px;\n}\n\n.profile-avatar-wrap {\n  width: 130px;\n  height: 130px;\n  border-radius: 999px;\n  padding: 4px;\n  background: linear-gradient(135deg, #52a8d8, #245f95);\n  box-shadow: 0 10px 24px rgba(36, 95, 149, 0.24);\n}\n\n.profile-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 999px;\n  border: 3px solid #ffffff;\n}\n\n.profile-main {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.profile-name {\n  margin: 0;\n  color: var(--profile-text);\n  font-size: clamp(1.6rem, 2vw, 2rem);\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n}\n\n.profile-email {\n  margin: 6px 0 12px;\n  color: #475569;\n  font-size: 0.98rem;\n}\n\n.profile-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.profile-meta-item {\n  border: 1px solid var(--profile-border);\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 12px;\n  padding: 10px 12px;\n}\n\n.profile-meta-label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.74rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--profile-muted);\n  font-weight: 600;\n}\n\n.profile-meta-value {\n  color: var(--profile-text);\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.profile-cards {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 18px;\n}\n\n.profile-card {\n  background: var(--profile-surface);\n  border: 1px solid var(--profile-border);\n  border-radius: 16px;\n  box-shadow: var(--profile-shadow);\n  padding: 18px 18px 14px;\n  animation: profile-fade-in 360ms ease both;\n}\n\n.profile-card-title {\n  margin: 0 0 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--profile-border);\n  font-size: 1.36rem;\n  font-weight: 700;\n  color: var(--profile-text);\n}\n\n.profile-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.profile-list li {\n  padding: 10px 0;\n  border-bottom: 1px dashed #d6dfef;\n  color: #334155;\n  font-size: 0.95rem;\n}\n\n.profile-list li:last-child {\n  border-bottom: 0;\n}\n\n.profile-field-label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--profile-muted);\n  font-size: 0.87rem;\n  font-weight: 600;\n}\n\n.profile-helper {\n  margin-top: 12px;\n  margin-bottom: 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: var(--profile-primary-soft);\n  border: 1px solid #cae8fb;\n  color: #0e537f;\n  font-size: 0.88rem;\n}\n\n.card-enterprises {\n  grid-column: span 4;\n}\n\n.card-notifications {\n  grid-column: span 4;\n}\n\n.card-timezone {\n  grid-column: span 4;\n}\n\n@keyframes profile-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1024px) {\n  .card-enterprises,\n  .card-notifications,\n  .card-timezone {\n    grid-column: span 6;\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-page {\n    padding: 16px 10px 28px;\n  }\n\n  .profile-hero {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    text-align: center;\n    gap: 14px;\n    padding: 22px 16px;\n  }\n\n  .profile-meta-grid {\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .profile-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .card-enterprises,\n  .card-notifications,\n  .card-timezone {\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
